import React, { useState, useEffect } from 'react';

// Sagas
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import {
  Modal,
} from 'reactstrap';

import WebhookForm from './WebhookForm';

function WebhookModal(props) {
  const { shown, t } = props;

  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    setModalOpen(shown);
  }, [shown]);

  const onSuccess = (x) => {
    setModalOpen(false);
    props.onSuccess(x);
  };

  const onCancel = () => {
    setModalOpen(false);
    props.onCancel();
  };

  const jsx = (
    <Modal
      size="md"
      isOpen={modalOpen}
    >
      <div className="modal-header">
        <h5
          className="modal-title mt-0"
          id="myLargeModalLabel"
        >
          {t('Create Webhook')}
        </h5>
        <button
          onClick={() => { onCancel(); }}
          type="button"
          className="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div className="modal-body">
        <WebhookForm onSuccess={onSuccess} />
      </div>
      <div className="modal-footer">
        <button
          type="button"
          onClick={() => { onCancel(); }}
          className="btn btn-soft-dark"
          data-dismiss="modal"
        >
          {t('Cancel')}
        </button>
        <button
          type="submit"
          form="WebhookForm"
          className="btn btn-primary"
        >
          {t('Submit')}
        </button>
      </div>
    </Modal>
  );

  return jsx;
}

WebhookModal.defaultProps = {
  shown: false,
  onSuccess: () => { },
  onCancel: () => { },
};

WebhookModal.propTypes = {
  // eslint-disable-next-line react/require-default-props
  t: PropTypes.any,
  shown: PropTypes.bool,
  onSuccess: PropTypes.func,
  onCancel: PropTypes.func,
};

export default connect(() => ({

}), {})(withTranslation()(WebhookModal));
